import { I18nManager, Platform, StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  inputRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inputRowId: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: Platform.OS == 'android' ? 170 : 80,
    marginBottom: 6
  },
  inputContainer: {
    flex: 1,
    marginTop: 18,
    marginBottom: 0,
    paddingTop: 0,
    marginHorizontal: 0,
  },
  inputText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.input,
  },
  identificationDropDown: {
    marginTop: 26,
    marginBottom: 0,
  },
  identificationDropDownFirst: {
    marginTop: 18,
    marginBottom: 0,
  },
  rowDropDownWrapper: {
    marginTop: 5,
    marginBottom: 0,
    flex: 1,
  },
  rowDropDown: {
    marginBottom: 0,
  },
  helperTextWrapperStyle: {
    marginTop: 0,
  },
  helperTextContainerStyle: {
    flexDirection: 'row',
    marginLeft: 4,
    marginTop: 6,
  },
  helperTextStyle: theme => ({
    color: theme.colors.textColorTwo,
    flex: 1,
    fontSize: 14.6,
    lineHeight: 18.7,
    marginLeft: I18nManager.isRTL ? 0 : 7,
    marginRight: I18nManager.isRTL ? 7 : 0,
    paddingTop: Platform.OS === 'ios' ? 3 : 1,
  }),
  rightSpacing: { marginRight: 10 },
  dropdown: {
    marginHorizontal: 0,
    height: 55,
  },
})
